/* global Fw, tinyMCE, tinymce, submittingForm */

(function($, d, g) {
    /* jshint validthis: true */
	"use strict";
    
    g.submittingForm = g.submittingForm !== undefined ? submittingForm : false;
    
    var tools_form;
    var utils_recaptcha;
    
    var currentSearchQuery;
    var $addingList;
    var $selectedList;
    
	var searchRequest;
    var searchTimeout;
    var searchDelay = 500;
    var expanded = false;
    
    function reloadPage() {
        g.location.reload();
    }
    
    function filterItem() {
        var txt = this.querySelector("span").textContent.replace(/\(|\)/g, "");
        if (txt.match(currentSearchQuery)) {
            $(this).removeClass("hide");
        } else {
            $(this).addClass("hide");
        }
    }
    
    function searchList(e) {
        var $ctn = $(this).closest(".list-selector-main");
        var k = e.which || e.keyCode;
        
        if (k === 13) {
            e.preventDefault();
        }
        
        currentSearchQuery = new RegExp($ctn.find(".list-selector-main-search input").val(), "i");
        $ctn.find(".list-selector-item").each(filterItem);
    }
    
    function ntczMoveUp(e) {
        var $el = $(this).closest(".ntc-zone"),
            $prev = $el.prev(),
            i = $el.index();
        
        moveElementWithTinyMCE($el, function() {
            $el.insertBefore($prev);
        });
        
        if (i - 1 === 0) {
            $(this).addClass("hide");
            $prev.find(".ntc-zone-btn-up").removeClass("hide");
        } else if (i + 1 === $el.parent().children().length) {
            $prev.find(".ntc-zone-btn-down").addClass("hide");
            $el.find(".ntc-zone-btn-down").removeClass("hide");
        }
    }
    function ntczMoveDown(e) {
        var $el = $(this).closest(".ntc-zone"),
            $next = $el.next(),
            i = $next.index();
        
        moveElementWithTinyMCE($el, function() {
            $el.insertAfter($next);
        });
        
        if (i + 1 === $el.parent().children().length) {
            $(this).addClass("hide");
            $next.find(".ntc-zone-btn-down").removeClass("hide");
        } else if (i - 1 === 0) {
            $next.find(".ntc-zone-btn-up").addClass("hide");
            $el.find(".ntc-zone-btn-up").removeClass("hide");
        }
    }
    function ntczDisplay(e) {
        $(this).closest(".ntc-zone").attr("data-hidden", !this.checked);
    }
    
    function processTemplate($form, callback) {
        var displayArray = [],
            orderArray = [],
            parser = tinymce.get("tinymceDOMParser"); //Transform xhtml elements
    
        // Transfer html content to the header and footer textarea
        parser.setContent($form.find(".ntc-zone-header").html());
        $form.find("[name='header']").val(parser.getContent());
        parser.setContent($form.find(".ntc-zone-footer").html());
        $form.find("[name='footer']").val(parser.getContent());
        parser.setContent("");
        
        // Compile zone names to display
        $form.find("input[name='displayCheck']:checked").each(function() {
            displayArray.push(this.value);
        });
        if ($form.find("input[name='displays']").length) {
            $form.find("input[name='displays']").val(displayArray.join(","));
        } else {
            $form.append("<input type='hidden' name='displays' value='" + displayArray.join(",") + "'/>");
        }
        
        // Compile zones ordering
        $form.find(".ntc-sortable-zones>.ntc-zone").each(function() {
            orderArray.push(this.getAttribute("data-name"));
        });
        if ($form.find("input[name='orders']").length) {
            $form.find("input[name='orders']").val(orderArray.join(","));
        } else {
            $form.append("<input type='hidden' name='orders' value='" + orderArray.join(",") + "'/>");
        }
        
        // Compile other zone's element ids, including "events", "jobs", and "blogs"
        $form.find(".ntc-component-ctn").each(function() {
            var array = [],
                name = $(this).closest(".ntc-zone").attr("data-name");
            
            $(this).find(".ntc-component").each(function() {
                array.push(this.getAttribute("data-id"));
            });
            if ($form.find("input[name='" + name + "']").length) {
                $form.find("input[name='" + name + "']").val(array.join(","));
            } else {
                $form.append("<input type='hidden' name='" + name + "' value='" + array.join(",") + "'/>");
            }
        });
        
        var bodyHtmlArray = [];
        var processingContentIncomplete = false;
        var imageNotFound = false;
        
        $.each(orderArray, function(k, v) {
            if (displayArray.indexOf(v) > -1 && !processingContentIncomplete) {
                var $zone = $form.find(".ntc-zone[data-name='" + v + "']"),
                    zoneData = $zone.data();
                
                if ($zone.find(".mce-container").length) {
                    var mceContent = tinymce.get(v).getContent();
                    if (mceContent && mceContent.length > 10) {
                        $zone.find("#" + v).val(mceContent);
                        mceContent = escapeXMLEntities2(mceContent);
                        
                        // In gmail and windows mail, for some reasons, the images max-width is not effective at all.
                        // So we have to go through each image in the body and manually set the max-width in each of them.
                        var shell = document.createElement("DIV");
                        var hasChanged = false;
                        shell.innerHTML = mceContent;
                        
                        $.each(shell.getElementsByTagName("IMG"), function(i, img) {
                            var w = 580;
                            if (img.naturalWidth === 0 && !img.complete) {
                                imageNotFound = true;
                            } else if (img.naturalWidth > w && (img.width > w || !img.width)) {
                                var styleWidth;
                                if (img.style.width) {
                                    styleWidth = img.style.width;
                                } else if (img.style.maxWidth) {
                                    styleWidth = img.style.maxWidth;
                                }
                                if (styleWidth) {
                                    if (styleWidth.match("px")) {
                                        w = parseInt(styleWidth);
                                    } else if (styleWidth.match("%")) {
                                        w = w * parseInt(styleWidth) / 100;
                                    }
                                }
                                img.width = w;
                                hasChanged = true;
                            }
                        });
                        if (hasChanged) {
                            mceContent = shell.innerHTML;
                        }
                        
                        bodyHtmlArray.push("<tr><td style=\"" + (zoneData.wrapStyle || "padding-top:30px;") + "\">" + mceContent + "</td></tr>");
                    }
                } else if ($zone.find(".ntc-component-ctn .ntc-component").length) {
                    var nCol = parseInt(zoneData.columns),
                        i = 0,
                        stringBuilder = "";
                    
                    // Serialize component's heading icon and text
                    var heading = $zone.find(".ntc-component-heading")[0].value;
                    stringBuilder += heading;
                    stringBuilder += "<table style=\"" + zoneData.tableStyle + "\">";
                    $zone.find(".ntc-component-ctn .ntc-component").each(function() {
                        if (i % nCol === 0) {
                            stringBuilder += "<tr>";
                        } else if (zoneData.spacingStyle) {
                            stringBuilder += "<td style=\"" + zoneData.spacingStyle + "\"></td>";
                        }
                        // Serialize component's content
                        var content = this.querySelector("table").outerHTML;
                        stringBuilder += "<td style=\"" + zoneData.tdStyle + "\">";
                        stringBuilder += content;
                        stringBuilder += "</td>";
                        if ((nCol - (i % nCol)) === 1) {
                            stringBuilder += "</tr>";
                        }
                        i++;
                    });
                    while (i % nCol !== 0) {
                        if (zoneData.spacingStyle) {
                            stringBuilder += "<td style=\"" + zoneData.spacingStyle + "\"></td>";
                        }
                        stringBuilder += "<td style=\"" + zoneData.tdStyle + "\"></td>";
                        i++;
                        if (i % nCol === 0) {
                            stringBuilder += "</tr>";
                        }
                    }
                    stringBuilder += "</table>";
                    
                    bodyHtmlArray.push("<tr><td style=\"" + (zoneData.wrapStyle || "padding-top:30px;") + "\">" + stringBuilder + "</td></tr>");
                }
            }
        });
        
        if (processingContentIncomplete) {
            setTimeout(function() {
                processTemplate($form, callback);
            }, 100);
            return null;
        }
        
        var body = "<table style=\"border-collapse:collapse;border:0;width:100%;\">" + bodyHtmlArray.join("") + "</table>";
        // Convert html content to valid xhtml content
        parser.setContent(body);
        body = escapeXMLEntities2(parser.getContent());
        if ($form.find("textarea[name='body']").length) {
            $form.find("textarea[name='body']").html(body);
        } else {
            $form.append("<textarea style='display:none;' name='body'>" + body + "</textarea>");
        }
        
        if (typeof callback === "function") {
            // Returns the callback function
            return callback(body);
        }
        
        // Returns the processed content
        return body;
    }
    function submitTemplate(e) {
        if (e) e.preventDefault();
        
        var $form = $(this);
        tools_form.validateForm($form);
        if ($form.hasClass("has-error") || g.submittingForm) {
            return false;
        }
        g.submittingForm = true;
        $form.find(".js-form-btn").addClass("disabled");
        
        // Process the raw data in the form
        processTemplate($form, function(content) {
            $form[0].submit();
        });
    }
    function saveAndPreviewTemplate(e) {
        if (e) e.preventDefault();
        
        var it = e ? e.target : this;
        var $form = $("#newsletterTemplateForm");
        tools_form.validateForm($form);
        if ($form.hasClass("has-error") || g.submittingForm) {
            return false;
        }
        g.submittingForm = true;
        $form.find(".js-form-btn").addClass("disabled");
        
        // Process the raw data in the form
        processTemplate($form, function(content) {
            $.ajax({
                url: $form.attr("action"),
                method: "post",
                cache: false,
                data: $form.serialize() + "&ajax=true",
                success: function(response) {
                    var id = response.trim().substr(8);
                    if (response.indexOf("success") !== -1 && id !== "-1") {
                        if (it.hasAttribute("data-preview")) {
                            // Insert new content to preview
                            var $parser = $("#newsTempPreviewInvoker");
                            $parser.find(".newsletter-header").html($form.find(".ntc-zone-header").html());
                            $parser.find(".newsletter-footer").html($form.find(".ntc-zone-footer").html());
                            $parser.find(".newsletter-body").html(content);
                            d.getElementById("newsTempPreviewWindow").removeAttribute("data-hidden");
                            encodePreviewTemplate();
                        }
                        // Update the template id especially for a new template
                        $form.find(".ntf-id").val(id);
                        pushQueryState("nlTemplateId", id);
                    } else {
                        popErrorComplete("Une erreur s'est produite");
                    }
                    g.submittingForm = false;
                    $form.find(".js-form-btn").removeClass("disabled");
                }
            });
        });
    }
    
    function encodePreviewTemplate() {
        try {
            var wi = d.getElementById("newsTempPreviewWindow");
            if (!$(wi).attr("data-hidden")) {
                wi.querySelector(".news-temp-preview-parser").innerHTML = decodeEntities(d.getElementById("newsTempPreviewInvoker").innerHTML);
                wi.style.display = "block";
                $("html, body").addClass("no-scroll");
            }
        } catch (err) {
        }
    }
    
    function closeTemplatePreviewWindow() {
        closeWindow('newsTempPreviewWindow');
        $('html, body').removeClass('no-scroll');
        pushQueryState("preview");
    }
    
    function ntcAddComponent(e) {
        var $zone = $(this).closest(".ntc-zone"),
            $ctn = $zone.find(".ntc-component-ctn"),
            select = $zone.find(".ntc-component-select")[0],
            option = select.item(select.selectedIndex),
            data = option ? option.dataset : {},
            tempHtml = $zone.find(".ntc-component-temp").html();
        
        if (select.value !== "") {
            var re, p;
            for (p in data) {
                re = new RegExp("\\[\\[" + p.toUpperCase() + "\\]\\]", "g");
                tempHtml = tempHtml.replace(re, data[p]);
            }
            $ctn.append(tempHtml);
            option.setAttribute("hidden", true);
            select.value = "";
        }
    }
    function ntcDeleteComponent(e) {
        var $el = $(this).closest(".ntc-component");
        
        $(this).closest(".ntc-zone")
            .find(".ntc-component-select option[value='" + $el.attr("data-id") + "']")
            .removeAttr("hidden");
        $el.remove();
    }

    function loadEventComponents(res) {
        var array = typeof res === "string" ? JSON.parse(res) : array;
        if (array && array[0]) {
            var $ctn = $(".ntc-zone-events");
            var tempHtml = $ctn.parent().find(".ntc-component-temp").html();
            var comHtml;

            for (var i = 0; i < array.length; i++) {
                var ev = array[i];
                var date = ev.timeStart;
                
                // Displays only the day and date
                if (date.indexOf("Le ") > -1) {
                    date = date.substr(date.indexOf("Le ") + 3);
                }
                if (date.indexOf(" &#224;") > -1) {
                    date = date.substr(0, date.indexOf(" &#224;"));
                }
                if (date.indexOf(" at") > -1) {
                    date = date.substr(0, date.indexOf(" at"));
                }

                comHtml = tempHtml.replace(/\[\[ID\]\]/g, ev.id)
                        .replace(/\[\[NAME\]\]/g, ev.name)
                        .replace(/\[\[DATE\]\]/g, date);
                $ctn.append(comHtml);
            }
        }
    }
    
    function loadPastEvents(response) {
        try {
            var json = JSON.parse(response.trim());
            var select = $(".ntc-zone[data-name='events'] .ntc-component-select");
            var optionBuilder = "";
            
            for (var j in json) {
                var event = json[j];
                optionBuilder += "<option value='" + event.id + "' data-id='" + event.id + "' data-date='" + event.timeStart + "' data-name='" + event.name + "'>" + event.timeStart + " - " + event.name + "</option>";
            }
            select.append(optionBuilder);
        } catch (e) {
            console.error(e);
        }
    }
    
    function cloneNewsletterItem(e) {
        if (g.submittingForm) return false;
        g.submittingForm = true;
        
        $(this).closest(".table-actions").find(".clone-nlitem-form").submit();
    }
    
    function activateElement(e) {
        if (e) e.preventDefault();
        
        if (g.submittingForm) return;
        g.submittingForm = true;
        
        ajax(this.getAttribute("data-url"), reloadPage, true);
    }
    
    function editElement(e) {
        if (e) e.preventDefault();
        
        var $it = $(this || e.currentTarget),
            form = d.getElementById($it.attr("data-form")),
            inputs = form.elements,
            data = $it.closest("tr").data(),
            name, eventEl, eventId;

            var listIds;

            //listIds for checkbox
            if(data.listid && data.listid.length > 0  && data.listid.includes(',')){
                listIds = data.listid.split(',');
            }
            else {
                listIds = data.listid;
            }
        
        if ($it.attr("data-hide-elements")) {
            $($it.attr("data-hide-elements"), form).hide();
        }
        if ($it.attr("data-show-elements")) {
            $($it.attr("data-show-elements"), form).show();
        }
    
        $.each(inputs, function(i, el) {
            if (!el.hasAttribute("ignore")) {
                name = el.name.toLowerCase();
                if (el.type === "checkbox" || el.type === "radio") {
                    if ((listIds > 0 && listIds == el.defaultValue) || (data.listid && data.listid.length > 0 && listIds.includes(el.defaultValue))) {
                        el.checked = true;
                    }
                    else
                        el.checked = data.hasOwnProperty(name) && data[name] === true;
                } else {
                    el.value = data.hasOwnProperty(name) ? data[name] : "";
                    
                    // BIND Complex selection with past and future events
                    if (name === "eventid" && data[name] != -1 && el.selectedIndex === -1) {
                        eventEl = el;
                        eventId = data[name];
                    }
                }
            }
        });
        
        // HANDLE Complex selection with past and future events
        if (eventEl && eventId) {
            // To modify these events, go to page/admin-registration.js
            if ($(eventEl).hasClass("registration-event-select-past")) {
                $(".registration-event-selector .select-futur-event").click();
                $(".registration-event-select").val(eventId);
            } else {
                $(".registration-event-selector .select-past-event").attr("data-extra", eventId).click();
            }
        }
        
        $(form).slideDown(400);
        $('html, body').animate({
            scrollTop: $(form).offset().top - $(".site-header").height()
        }, 300);
    }
    
    /* START Old autocomplete search */
    function autoSearchAccounts(e) {
        var inp = this,
            ctn = inp.parentElement,
            list = ctn.querySelector(".autocomplete-list"),
            icon = ctn.querySelector(".processing-loader"),
            val = inp.value.trim();
        
        switch(e.type) {
            case "keydown":
            case "keyup":
            case "keypress":
                var k = e.which || e.keyCode,
                    selectedItem = list.querySelector(".autocomplete-item.over"),
                    nextItem = null;
                
                try {
                    if (k === 13) { //Enter
                        e.preventDefault();
                        chooseSearchedAccount.call(selectedItem);
                        _hideList();
                    } else if (k === 38) { //Up arrow
                        e.preventDefault();
                        if (selectedItem) {
                            nextItem = selectedItem.previousElementSibling;
                        } else {
                            nextItem = list.lastElementChild;
                        }
                        overSearchedAccount.call(nextItem);
                        unoverSearchedAccount.call(selectedItem);
                        scrollElementToView(nextItem, false, list);
                    } else if (k === 40) { //Down arrow
                        e.preventDefault();
                        if (selectedItem) {
                            nextItem = selectedItem.nextElementSibling;
                        } else {
                            nextItem = list.firstElementChild;
                        }
                        overSearchedAccount.call(nextItem);
                        unoverSearchedAccount.call(selectedItem);
                        scrollElementToView(nextItem, true, list);
                    }
                } catch (ex) {
                }
                break;
            case "input":
                _search();
                break;
            case "focus":
                if (val !== "") _showList();
                break;
            case "blur":
                setTimeout(_hideList, 100);
                break;
        }
        
        function _search() {
            if (searchRequest) searchRequest.abort();
            if (searchTimeout) clearTimeout(searchTimeout);

            if (val !== inp.getAttribute("data-mem")) {
                $(icon).addClass("is-processing");
                
                if (!val || val.length < 1) {
                    inp.setAttribute("data-mem", val);
                    _autoSearchAccountsComplete("");
                    _hideList();
                } else if (val.length === 1) {
                    inp.setAttribute("data-mem", val);
                    _autoSearchAccountsComplete();
                } else {
                    searchTimeout = setTimeout(function() {
                        inp.setAttribute("data-mem", val);
                        searchRequest = $.get({
                            url: "/action/pmiAjaxAccounts",
                            cache: false,
                            data: { q: val, count: 25 },
                            dataType: "json",
                            success: _autoSearchAccountsComplete,
                            error: function(xhr) {
                                console.log(xhr.statusText);
                            }
                        });
                    }, searchDelay);
                }
            }
        }
        function _autoSearchAccountsComplete(response) {
            if (response !== undefined && response !== null) {
                list.innerHTML = "";
                try {
                    var o = typeof response === "string" ? JSON.parse(response) : response;
                    for (var i = 0; i < o.pmiaccounts.length; i++) {
                        var pa = o.pmiaccounts[i],
                            el = d.createElement("DIV");
                        
                        el.className = "autocomplete-item";
                        el.setAttribute("data-id", pa.id);
                        el.innerHTML = pa.lastName + ", " + pa.firstName + " <small>" + pa.email + "</small>";
                        list.appendChild(el);
                    }
                    _showList();
                } catch (err) {
                }
            }
            
            $(icon).removeClass("is-processing");
        }
        
        function _showList() {
            list.style.display = "block";
        }
        function _hideList() {
            list.style.display = "none";
        }
    }
    function chooseSearchedAccount(e) {
        if (!this) throw "this is " + this;
        
        var $item = $(this);
        $item.closest(".input-ctn").find(".autocomplete-member-input")[0].value = this.textContent;
        $item.closest("form")[0].elements.accountId.value = this.getAttribute("data-id");
        // Clear the list leaving only the chosen element
        var clone = this.cloneNode(true);
        $item.closest(".autocomplete-list").empty().append(clone);
    }
    function overSearchedAccount(e) {
        if (!this) throw "this is " + this;
        
        $(this).addClass("over");
    }
    function unoverSearchedAccount(e) {
        if (!this) throw "this is " + this;
        
        $(this).removeClass("over");
    }
    /* END Old autocomplete search */
    
    function masterSearchAccount(e) {
        var btn = this,
            key = btn.getAttribute("data-key") || "",
            hasNon = key.indexOf("non") === 0,
            data = "";
    
        if (searchRequest) searchRequest.abort();
        if (searchTimeout) clearTimeout(searchTimeout);
        
        $(".list-selector-addition-loader").addClass("is-processing");
        data += "count=" + $addingList.attr("data-count");
        if (key !== "") data += "&" + (hasNon ? key.substring(3) : key) + "=" + !hasNon;
        searchRequest = $.get({
            url: "/action/pmiAjaxAccounts",
            cache: false,
            data: data,
            dataType: "json",
            success: function(response) {
                $(".list-selector-main .processing-loader").removeClass("is-processing");
                $addingList.html("");
                try {
                    var o = typeof response === "string" ? JSON.parse(response) : response;
                    appendSearchedAccounts(o.pmiaccounts);
                } catch (err) {
                }
            },
            error: function(xhr) {}
        });
    }
    function searchAccountsList(e) {
        var inp = this,
            $ctn = $(inp).closest(".list-selector-main"),
            val = inp.value.trim();
    
        if (searchRequest) searchRequest.abort();
        if (searchTimeout) clearTimeout(searchTimeout);

        if (val !== inp.getAttribute("data-mem")) {
            $ctn.find(".list-selector-main-search .processing-loader").addClass("is-processing");

            if (!val || val.length < 1) {
                inp.setAttribute("data-mem", val);
                _searchAccountsSuccess("");
            } else if (val.length === 1) {
                inp.setAttribute("data-mem", val);
                _searchAccountsSuccess();
            } else {
                searchTimeout = setTimeout(function() {
                    inp.setAttribute("data-mem", val);
                    searchRequest = $.get({
                        url: "/action/pmiAjaxAccounts",
                        cache: false,
                        data: "count=" + $addingList.attr("data-count") + "&q=" + val,
                        dataType: "json",
                        success: _searchAccountsSuccess,
                        error: function(xhr) {}
                    });
                }, searchDelay);
            }
        }

        function _searchAccountsSuccess(response) {
            $ctn.find(".processing-loader").removeClass("is-processing");
            
            if (response !== undefined && response !== null) {
                $addingList.html("");
                try {
                    var o = typeof response === "string" ? JSON.parse(response) : response;
                    appendSearchedAccounts(o.pmiaccounts);
                } catch (err) {
                }
            }
        }
    }
    function appendSearchedAccounts(accounts) {
        for (var i = 0; i < accounts.length; i++) {
            var pa = accounts[i],
                el = d.createElement("DIV"),
                content = "";

            if (!d.querySelector(".pmi-account-" + pa.id)) {
                el.className = "list-selector-item";
                el.setAttribute("data-id", pa.id);
                content += "<a class='btn'></a><span>" + pa.lastName + ", " + pa.firstName + " <small>" + pa.email;
                if (pa.pmiorgJoinDate !== undefined) {
                    content += ", joined " + pa.pmiorgJoinDate;
                }
                if (pa.pmiorgExpirationDate !== undefined) {
                    content += ", expiration " + pa.pmiorgExpirationDate;
                }
                content += "</small></span>";
                el.innerHTML = content;
                if ($selectedList.find(".list-selector-item[data-id='" + pa.id + "']")[0]) {
                    $(el).addClass("hide");
                }
                $addingList.append(el);
            }
        }
    }
    function addOrRemoveItem(e) {
        var item = $(this).closest(".list-selector-item")[0];
        
        if ($.contains($addingList[0], item)) {
            $selectedList.append(item.cloneNode(true));
            $(item).addClass("hide");
            $(this).closest("form").find(".js-form-error-message").addClass("hide");
        } else if ($.contains($selectedList[0], item)) {
            $addingList.find(".list-selector-item[data-id='" + item.getAttribute("data-id") + "']").removeClass("hide");
            item.parentElement.removeChild(item);
        }
    }
    function addOrRemoveAllItems(e) {
        if (this.getAttribute("data-type") === "remove") {
            $addingList.children().removeClass("hide");
            $selectedList.empty();
        } else {
            $selectedList.append($addingList.children(":not(.hide)").clone(true));
            $addingList.children().addClass("hide");
            $(this).closest("form").find(".js-form-error-message").addClass("hide");
        }
    }
    function submitAccountsList(e) {
        if (e) e.preventDefault();
        
        if (g.submittingForm) return false;
        
        var listId = this.getAttribute("data-id"),
            progrsEl = d.querySelector(".list-selector-submission-progress"),
            completeCount = 0,
            selectedCount = $selectedList.children().length;
        
        if (selectedCount > 0 ) {
            g.submittingForm = true;
            progrsEl.innerHTML = "Complete... " + completeCount + "/" + selectedCount;
            $selectedList.children().each(_send);
        } else {
            $(this).closest("form").find(".js-form-error-message").removeClass("hide");
        }
        
        function _send() {
            var data = {
                ajax: true,
                listAccount: true,
                listId: listId,
                accountId: this.getAttribute("data-id")
            };
            
            $.ajax({
                url: "/action/pmiNewsletter",
                method: "post",
                cache: false,
                data: data,
                dataType: "text",
                success: _success
            });
        }
        
        function _success(response) {
            completeCount++;
            progrsEl.innerHTML = "Complete... " + completeCount + "/" + selectedCount;
            
            if (completeCount === selectedCount) reloadPage();
        }
    }
    
    function scrollElementToView(el, bottom, ctn) {
        var parent = ctn || el.offsetParent,
            ph = parent.clientHeight,
            st = parent.scrollTop,
            eh = el.offsetHeight,
            et = el.offsetTop;
        
        if (et + eh > ph + st || et < st) {
            parent.scrollTop = !bottom ? et : et + eh - ph;
        }
    }
    
    function subscribeAccount(e) {
        if (e) e.preventDefault();
        
        if (g.submittingForm) return;
        g.submittingForm = true;
        
        var str = "ajax=true&listAccount=true";
        str += "&id=" + $(this).closest("tr").attr("data-id");
        str += "&status=" + this.getAttribute("data-status");
        
        $.ajax({
            url: "/action/pmiNewsletter",
            method: "post",
            data: str,
            cache: false,
            success: reloadPage
        });
    }
    
    function changeComponentNewsletterList() {
        var $ctn = $($(this).closest(".newsletter-component")[0] || $(this).closest(".newsletter-outer-ctn")[0]),
            $inp = $ctn.find("input.com-settings-newsletter-list-id"),
            val = this.value;
        
        updateLabelLangs($inp.attr("data-key"), val, $("html").attr("langs"), function() {
            $inp.val(val);
            if (val === "") {
                $ctn.find(".com-settings-newsletter-list-alert").removeClass("hide");
            } else {
                $ctn.find(".com-settings-newsletter-list-alert").addClass("hide");
            }
        });
    }
    
    function optIn(captcha, form, btn) {
        var $form = $(form);
        //tools_form.validateForm($form); Form validation has already been done through the utils.recaptcha function
        if ($form.hasClass("has-error") || g.submittingForm) {
            return false;
        }
        g.submittingForm = true;
        
        var $success = $form.find(".ncf-success-response");
        var $error = $form.find(".ncf-error-response");

        $success.hide();
        $error.hide();
        $.ajax({
            url: "/action/pmiSubscribe",
            method: "post",
            data: "ajax=true&captcha=" + captcha + "&"  + $form.serialize(),
            cache: false,
            success: function(response) {
                g.submittingForm = false;
                if (response !== "success--1") {
                    $success.show();
                    setTimeout(function() { $success.hide(); }, 9000);
                    $form.find("[name='firstName']").val("");
                    $form.find("[name='lastName']").val("");
                    $form.find("[name='email']").val("");
                } else {
                    $error.show();
                    setTimeout(function() { $error.hide(); }, 9000);
                }
                grecaptcha.reset();
            },
            error: function() {
                g.submittingForm = false;
                $error.show();
                setTimeout(function() { $error.hide(); }, 9000);
                grecaptcha.reset();
            }
        });
    }
    
    function initTinyMCE(selector){
        if ($('body').hasClass('is-logged-in') && $(selector).length) {
            var settings = {
                mode: "specific_textareas",
                selector: selector,
                content_css: ["/shared/websites/www.pmi.com/assets/tinymce/newsletter.css"],
                menubar: true,
                language: ($("html").attr("lang") === 'fr') ? "fr_FR" : "en_CA",
                plugins: ["image imagetools advlist autolink lists link charmap print anchor",
                    "searchreplace visualblocks code textcolor",
                    "insertdatetime media table contextmenu paste filemanager hr fullscreen"],
                menu: {
                    file: {title: 'File', items: 'newdocument print'},
                    edit: {title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall | searchreplace'},
                    insert: {title: 'Insert', items: 'filemanager link media | charmap anchor hr insertdatetime'},
                    view: {title: 'View', items: 'visualblocks visualaid'},
                    format: {title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat'},
                    table: {title: 'Table', items: 'inserttable tableprops deletetable | cell row column'},
                    tools: {title: 'Tools', items: 'code'}
                },
                toolbar: "undo redo | styleselect fontsizeselect | filemanager link | bold italic underline forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent ",
                relative_urls: false,
                remove_script_host: false,
                entity_encoding: "numeric",
                forced_root_blocks: "p",
                paste_as_text: true,
                contextmenu: "link inserttable | bold italic underline | cell row column deletetable | fontsizeselect",
                image_caption: true,
                image_advtab: true,
                imagetools_toolbar: "imageoptions",
                filemanager_title: ($("html").attr("lang") === 'fr') ? "Gestion d'images" : "File Manager",
                theme_advanced_blockformats: "p,h1,h2,h3,h4,h5,h6,blockquote",
                fontsize_formats: "12px 13px 14px 15px 16px 18px 20px 22px 24px 28px 30px 32px 36px 40px 50px 60px",
                textcolor_cols: "7",
                textcolor_rows: "7",
                textcolor_map: mceColorMap,
                valid_elements: "*[*]",
            };

            newsletterTinyMCEInit(settings);
        }
    }
    
	function newsletterTinyMCEInit(settings) {
        if (typeof tinymce === "object") {
            tinymce.init(settings);
        } else {
            setTimeout(function () {
                initTinyMCE(settings);
            }, 1000);
        }
    }
    
    function parseHeadingTitles() {
        const $editZones = $(".ntc-component-heading-title-edit");
        if (!$editZones[0]) {
            return;
        }

        $editZones.each((i, e) => {
            const $input = $(e).closest(".ntc-zone").find("textarea.ntc-component-heading");
            const $content = $("<div>" + $input.val() + "</div>");
            const $title = $content.children("h2, h3");
            let newText = e.textContent;

            if (newText !== $title.text()) {
                $title.text(newText);
                $input.val($content.html());
            }
        });

        setTimeout(parseHeadingTitles, 1000);
    }
    
	function init() {
        tools_form = Fw.component.models().form;
		utils_recaptcha = Fw.component.models().utils.recaptcha;
        
        // Newsletter Component
        $(".com-settings-newsletter-list").on("change", changeComponentNewsletterList);
		$(".newsletter-component-submit, .newsletter-email-subscribe").each(function() {
			var btn = this;
			utils_recaptcha(btn, optIn, true, $(btn).closest(".newsletter-component-inputs-outer"));
		});
        
        initTinyMCE(".newsletter-tiny-mce:not([id^='mce_'])");
        
        //INIT STOP
        if (!d.querySelector(".newsletter-zone")) return;
        
        encodePreviewTemplate();
        
        if (document.getElementById("newsTempPreviewWindow")) {
            d.querySelector("#newsTempPreviewWindow .full-window-close").onclick = closeTemplatePreviewWindow;
        }
        
        $(".ntc-zone-btn-up").on("click", ntczMoveUp);
        $(".ntc-zone-btn-down").on("click", ntczMoveDown);
        $(".ntc-zone-btn-display input").on("change", ntczDisplay);
        $("#newsletterTemplateForm").on("submit", submitTemplate);
        $(".ntf-save-btn").on("click", saveAndPreviewTemplate);
        // Hide placement buttons at the first and last position
        $(".ntc-zone:first-child .ntc-zone-btn-up, .ntc-zone:last-child .ntc-zone-btn-down", $(".ntc-sortable-zones")).addClass("hide");
        
        $(".ntc-component-btn-add").on("click", ntcAddComponent);
        $(".ntc-component-ctn").on("click", ".ntc-component-btn-delete", ntcDeleteComponent);
        $(".ntc-component-ctn").sortable({
            items: ".ntc-component",
            handle: ".ntc-component-btn-move",
            forceHelperSize: true,
            tolerance: "pointer",
            opacity: 0.8
        });
        // Ajax load the event to the component list
        if ($(".ntc-zone-events").attr("data-ids")) {
            ajax("/action/pmiAjaxGetEvent?ids=" + $(".ntc-zone-events").attr("data-ids"), loadEventComponents, true);
        }
        // Ajax load all the past events to the select
        ajax("/action/pmiEvent?getPastEvents=true", loadPastEvents, true);
        
        $(".clone-nlitem-btn").on("click", cloneNewsletterItem);
        
        $(".activate-btn, .deactivate-btn").on("click", activateElement);
        $(".edit-nlelement").on("click", editElement);
        
        $addingList = $(".list-selector-main-items.list-selector-addition");
        $selectedList = $(".list-selector-main-items.list-selector-selection");
        $(".unsubs-nl-account, .subs-nl-account").on("click", subscribeAccount);
        // Deprecated
        $(".autocomplete-member-input").on("keydown input focus blur", autoSearchAccounts);
        $(".autocomplete-list").on("click", ".autocomplete-item", chooseSearchedAccount);
        $(".autocomplete-list").on("mouseover", ".autocomplete-item", overSearchedAccount);
        $(".autocomplete-list").on("mouseout", ".autocomplete-item", unoverSearchedAccount);
        // New
        $(".list-selector-master-btn").on("click", masterSearchAccount);
        $(".list-selector-main-search input").on("input", searchAccountsList);
        $(".list-selector-main-items").on("click", ".btn", addOrRemoveItem);
        $(".list-selector-all-btn").on("click", addOrRemoveAllItems);
        $(".create-subscribers-btn").on("click", submitAccountsList);
        
        // Detect changes in the double-click sitelabel and parse the new text in the hidden input
        parseHeadingTitles();

        $(".selectBox-campaign").on("click", function () {
            var checkboxes = $("#checkboxes-campaign");
            if (!expanded) {
                checkboxes.show();
                expanded = true;
            } else {
                checkboxes.hide();
                expanded = false;
            }
        });
        $("#checkboxes-campaign input[type='checkbox']").on("change", getCampaignCheckedValues);
        
    }

    function getCampaignCheckedValues() {
        var selectedCampaign = [];
        $("input[type='checkbox']:checked").each(function () {
            if($(this).val() != 'on')
            selectedCampaign.push($(this).val());
        });

        $('#newsletterCampaignForm input[name="listId"]').val(selectedCampaign.join(','));
    }
	
	$(g).ready(init);
	
})(jQuery, document, window);
/*
function putListAccount(listId, pmiNumber, email, firstName, lastName) {
    $.get({
        url: "/action/pmiAjaxAccounts",
        cache: false,
        data: "count=1&q=" + pmiNumber,
        dataType: "json",
        success: function(resp) {
            try {
                var o = typeof resp === "string" ? JSON.parse(resp) : resp;
                var pa = o.pmiaccounts[0];
                var dat = {
                    ajax: true,
                    listAccount: true,
                    listId: listId
                };
                if (pa && pa.id) {
                    dat.accountId = pa.id;
                } else {
                    dat.email = email;
                    dat.firstName = firstName;
                    dat.lastName = lastName;
                }

                $.ajax({
                    url: "/action/pmiNewsletter",
                    method: "post",
                    cache: false,
                    data: dat,
                    dataType: "text"
                });
            } catch (err) {
                console.err(err);
            }
        },
        error: function(xhr) {}
    });
}*/